var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.248,
    height: 21.063,
    viewBox: "0 0 16.248 21.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-document",
    "data-name": "Icon ionic-ios-document",
    transform: "translate(-6.813 -3.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M21.555,8.9h4.564a.248.248,0,0,0,.251-.251h0a1.484,1.484,0,0,0-.537-1.149l-3.827-3.19a1.611,1.611,0,0,0-1.033-.371h0a.37.37,0,0,0-.371.371V7.952A.953.953,0,0,0,21.555,8.9Z",
    transform: "translate(-3.81 -0.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M15.488,7.95V3.938H8.918A1.61,1.61,0,0,0,7.313,5.543V22.4A1.61,1.61,0,0,0,8.918,24H20.955a1.61,1.61,0,0,0,1.6-1.6V10.207H17.745A2.26,2.26,0,0,1,15.488,7.95Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.15f0942349205cb39a43cea6f0da3564.svg";
export { ForwardRef as ReactComponent };